<template>
    <generic-page>
        <div class="text-center py-3">
            <h4 class="mb-1">{{ $t("Random Call") }}</h4>
            <div class="text-secondary small">
                {{ $t("Live video calls with new people") }}
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
                <span class="h5 mb-0">{{ oppositeCount }}</span>
                <span class="text-secondary ml-1">{{ oppositeLabel }}</span>
            </div>
            <div class="small text-secondary">
                {{ minutesRemaining }} {{ $t("minutes remaining") }}
            </div>
        </div>

        <div v-if="oppositeCount === 0" class="text-center py-5 text-secondary">
            <font-awesome-icon
                size="3x"
                icon="fa-duotone fa-users-slash"
                class="mb-3"
            />
            <div>{{ $t("Nobody in the queue right now") }}</div>
            <div class="small mt-1">
                {{ $t("Be the first to join — others will match with you when they arrive") }}
            </div>
        </div>

        <div v-else class="d-flex flex-wrap mb-3">
            <div
                :key="entry.userId"
                v-for="entry in previewEntries"
                class="text-center p-1"
                style="width: 33.33%"
            >
                <img
                    v-if="entry.avatarUrl"
                    :src="entry.avatarUrl"
                    class="rounded w-100"
                    style="aspect-ratio: 1; object-fit: cover"
                />
                <div v-else class="bg-light rounded d-flex align-items-center justify-content-center" style="aspect-ratio: 1">
                    <font-awesome-icon icon="fa-duotone fa-user" size="2x" class="text-secondary" />
                </div>
                <div class="small mt-1 text-truncate">{{ entry.name }}</div>
                <div class="small text-secondary">{{ entry.age }}</div>
            </div>
        </div>

        <div class="position-sticky bottom-0 bg-white py-2">
            <b-btn
                v-if="!inQueue"
                @click="join"
                :disabled="joining"
                variant="primary"
                size="lg"
                pill
                block
            >
                <font-awesome-icon icon="fa-duotone fa-video" class="mr-1" />
                {{ $t("Join Queue") }}
            </b-btn>

            <b-btn
                v-else
                @click="leave"
                variant="secondary"
                size="lg"
                pill
                block
            >
                <font-awesome-icon icon="fa-duotone fa-circle-stop" class="mr-1" />
                {{ $t("Leave Queue") }}
            </b-btn>

            <div v-if="inQueue" class="text-center small text-secondary mt-2">
                {{ $t("Looking for a match...") }}
            </div>

            <div class="text-center small text-secondary mt-2">
                {{ skipsLabel }}
            </div>
        </div>
    </generic-page>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    data() {
        return {
            joining: false,
        };
    },
    computed: {
        ...mapState("randomCall", [
            "inQueue",
            "role",
            "minutesRemaining",
            "previewLimit",
            "skip",
        ]),
        ...mapGetters("randomCall", ["oppositeQueue", "oppositeCount"]),
        oppositeLabel() {
            if (this.role === "creators") {
                return this.$t("customers waiting");
            }
            return this.$t("creators waiting");
        },
        previewEntries() {
            return this.oppositeQueue.slice(0, this.previewLimit);
        },
        skipsLabel() {
            const remaining = Math.max(
                0,
                (this.skip?.freeAllowance ?? 0) - (this.skip?.count ?? 0)
            );
            return `${remaining} ${this.$t("free skips left")}`;
        },
    },
    methods: {
        async join() {
            this.joining = true;
            try {
                await this.$store.dispatch("randomCall/enterQueue");
            } catch (e) {
                // server already surfaces a credit dialog via error response
            } finally {
                this.joining = false;
            }
        },
        leave() {
            this.$store.dispatch("randomCall/leaveQueue");
        },
    },
};
</script>
